import { SurveyQuestionResponseStatistics } from '@occc/graphql';

import { ChartType } from './types';

import { buildTooltipProps } from './utils/buildTooltipProps';
import { buildSelectedRangeTooltipProps } from './utils/buildSelectedRangeTooltipProps';
import {
  BarChart,
  BarPieceItem,
  Box,
  PieChart,
  PiePieceItem,
  TableCell,
} from '../../../design-system';

interface LocationRowGenericChartProps<ItemType> {
  columnsCount: number;
  type: ChartType;
  items: ItemType[];
}
interface LocationRowPieChartProps extends LocationRowGenericChartProps<PiePieceItem> {
  type: 'pie';
}
interface LocationRowBarChartProps
  extends LocationRowGenericChartProps<
    BarPieceItem<SurveyQuestionResponseStatistics['sliderResponseRanges'][0]>
  > {
  type: 'bar';
}

export const LocationRowChart = ({
  items,
  type,
  columnsCount,
}: LocationRowPieChartProps | LocationRowBarChartProps) => {
  return (
    <TableCell colSpan={columnsCount}>
      <Box height={200}>
        {type === 'pie' && (
          <PieChart
            items={items}
            legendWrapperStyle={{ left: '30%' }}
            legendContentWrapperProps={{
              gridTemplateColumns: 'repeat(2, 1fr)',
            }}
          />
        )}

        {type === 'bar' && (
          <BarChart<SurveyQuestionResponseStatistics['sliderResponseRanges'][0]>
            items={items}
            buildSelectedRangeTooltipProps={buildSelectedRangeTooltipProps}
            buildTooltipProps={buildTooltipProps}
            shouldShowLegend={false}
          />
        )}
      </Box>
    </TableCell>
  );
};
